import { Route, Routes } from "react-router-dom";
import { Routes as FleetTransferRoutes } from "./routes";
import { FleetTransferRouterCmp } from "./types";
import { TransferSearchPage } from "../pages/TransferSearchPage";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const FleetTransferRouter: FleetTransferRouterCmp = () => {
  return (
    <>
      <Routes>
        <Route path={TransferSearchPage.route} element={<TransferSearchPage />} />
      </Routes>
    </>
  );
};

FleetTransferRouter.route = FleetTransferRoutes.FleetTransferRouter;

export default FleetTransferRouter;
